import { IEnumToggleProp } from 'helpers/type';
import { AppConfig, RegionConfig } from './type';

const FEATURE_TOGGLES: IEnumToggleProp<boolean> = {
    LOAD_REDUX_DEVTOOLS: true,
    FEATURE_PRODUCT_MANAGEMENT: true,
    FEATURE_CHECKOUT_ACTIONS: true,
    FEATURE_SSP_ACTIONS: true,
    FEATURE_AVOID_INVALID_ERROR_TRACK: true,
};

export const auConfig: RegionConfig = {
    PAY_INVOICE: 'https://sit.store.myob.com.au/pages/payments.aspx?action=InvoicePayment',
    HELP_LINK: 'https://www.myob.com/au/contact-us',
};

export const nzConfig: RegionConfig = {
    PAY_INVOICE: 'https://sit.store.myob.co.nz/pages/payments.aspx?action=InvoicePayment',
    HELP_LINK: 'https://www.myob.com/nz/contact-us',
};

const config: AppConfig = {
    AUTHENTICATION_AUTHORITY: 'https://sit.login.myob.com',
    AUTHENTICATION_WEB_CLIENT_ID: 'self-service-portal-web',
    AUTHENTICATION_BFF_CLIENT_ID: 'self-service-portal-bff',
    PCI_CARD_PORTAL_URL: 'https://localhost:4000/portals/selfportalweb',
    PCI_CARD_PORTAL_ORIGIN: 'https://localhost:4000',
    SEGMENT_WRITE_KEY: '', // Removed key for local environment to save Monthly Tracked Users
    MY_ACCOUNT_MY_BILLS_LINK: 'https://sit-myaccount.sab.dev.myob.com/myBills',
    FEATURE_TOGGLES,
};

export default config;
